import brand from '@/config/brand';
import { siteContactPublicRef } from '@/composables/useSiteContact';
import { translate } from '@/composables/useI18n';

/** Nombre de tienda: API pública > env VUE_APP_STORE_NAME > brand.js */
export function getStoreName() {
  const c = siteContactPublicRef.value;
  if (c && typeof c === 'object' && c.store_name) {
    return String(c.store_name).trim();
  }
  return brand.storeName;
}

export function buildPageTitle(pageTitle) {
  const name = getStoreName().toUpperCase();
  return pageTitle ? `${pageTitle} | ${name}` : name;
}

export function setDocumentTitle(pageTitle) {
  if (typeof document !== 'undefined') {
    document.title = buildPageTitle(pageTitle);
  }
}

/**
 * Título de ruta según idioma activo: si `meta.titleKey` existe, lo traduce
 * contra el catálogo i18n usando el locale persistido (godea_locale); si no,
 * devuelve el `meta.title` ES nativo (fallback). El título ES queda en la meta
 * para SEO/OG (que no cambia de idioma), el visible se traduce acá.
 */
export function resolveRouteTitle(meta = {}) {
  if (meta.titleKey) {
    let stored = 'es';
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        stored = localStorage.getItem('godea_locale') || 'es';
      } catch {
        stored = 'es';
      }
    }
    const resolved = translate(stored, meta.titleKey);
    if (resolved && resolved !== meta.titleKey) {
      return resolved;
    }
  }
  return meta.title;
}
